import { createContext, useContext, useState } from 'react';

const TargetContext = createContext();

const initialState = {
  isOpenFormUpsert: false,
  isEditFormUpsert: false,
  selectedTarget: null,
  alertProps: {},
};

const initialFilterState = {
  page: 1,
  limit: 10,
  sort: { field: 'id', order: 'desc' },
  appliedAt: new Date(),
  brand: null,
};

const TargetProvider = ({ children }) => {
  const [state, setState] = useState(initialState);
  const [filterState, setFilterState] = useState(initialFilterState);

  const updateState = (payload) => setState((prev) => ({ ...prev, ...payload }));
  const updateFilterState = (payload) => setFilterState((prev) => ({ ...prev, ...payload }));
  const resetState = () => setState(initialState);
  const resetFilterState = () => setFilterState(initialFilterState);

  return (
    <TargetContext.Provider value={{ updateState, updateFilterState, resetState, resetFilterState, state, filterState }}>{children}</TargetContext.Provider>
  );
};

export const useTargetState = () => {
  return useContext(TargetContext);
};

export default TargetProvider;
